import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Injector,
  Input,
  OnInit,
} from '@angular/core';
import { HeaderActionButton } from '@app/components/header-action-buttons/header-action-buttons.model';
import { ActiveModal } from '@app/modules/core-modal/models/active.modal';
import { ModalComponent } from '@app/modules/modal-components-common/modal.component';
import {
  ModalCommandActions,
  ModalContentAlign,
} from '@app/modules/modal/modal.enums';
import { ModalButton } from '@app/modules/modal/modal.types';
import { E2E_ATTRIBUTES } from '@app/shared/types/enums/e2e-attributes.enum';
import { I18n } from '@app/i18n/strings-keys';

export enum ConfirmIconVariant {
  First = 'icon-ok-circle',
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'confirm',
  styleUrls: ['./confirm.component.scss'],
  templateUrl: './confirm.component.html',
  standalone: false,
})
export class ConfirmComponent extends ModalComponent implements OnInit {
  @Input() public title = '';
  @Input() public contentTitle = '';
  @Input() public message = '';
  @Input() public messageParams: Record<string, any>;
  @Input() public contentAlign: ModalContentAlign = ModalContentAlign.CENTER;
  @Input() public hasIcon = false;
  @Input() public iconVariant: ConfirmIconVariant;
  @Input() public set okText(text: string) {
    if (text && typeof text === 'string') {
      this.okButton.text = text;
    }
  }
  @Input() public set cancelText(text: string) {
    if (text && typeof text === 'string') {
      this.cancelButton.text = text;
    }
  }

  @HostBinding('attr.e2e-attr')
  public e2eAttr: string = E2E_ATTRIBUTES.CONFIRM_COMPONENT;
  public E2E_ATTRIBUTES: typeof E2E_ATTRIBUTES = E2E_ATTRIBUTES;
  public headerActionButtons: HeaderActionButton[];

  public confirmButtons: ModalButton[];

  private okButton: ModalButton = {
    text: I18n.CommonButtons.Ok,
    action: ModalCommandActions.APPLY,
    style: 'x_confirm-btn x_primary',
    e2eAttr: E2E_ATTRIBUTES.CONFIRM_COMPONENT_MODAL_FOOTER_BUTTON_CONFIRM,
  };
  private cancelButton: ModalButton = {
    text: I18n.CommonActions.Cancel,
    action: ModalCommandActions.CANCEL,
    style: 'x_confirm-btn x_secondary',
    e2eAttr: E2E_ATTRIBUTES.CONFIRM_COMPONENT_MODAL_FOOTER_BUTTON_CANCEL,
  };

  public constructor(
    public activeModal: ActiveModal,
    injector: Injector,
  ) {
    super(injector);
    this.headerActionButtons = [
      {
        callback: this.close.bind(this),
      },
    ];
  }

  public ngOnInit(): void {
    this.confirmButtons = [this.cancelButton, this.okButton];
  }

  public buttonClick(button: ModalButton) {
    this.activeModal.execute({
      action: button.action,
      payload: button.payload,
    });
  }

  private close() {
    this.activeModal.execute({
      action: ModalCommandActions.CLOSE,
    });
  }
}
